import { instance } from '@/services/cc/instance';

export const listConsole = (param) => instance.post('/console/listconsole', param);

export const queryConsoleById = (param) => instance.post('/console/queryconsolebyid', param);
